// extracted by mini-css-extract-plugin
module.exports = {"game_parent":"style_game_parent__0y5et","fixed":"style_fixed__1H8p_"};